import { render, staticRenderFns } from "./SuppliesStatistic.vue?vue&type=template&id=eae22ab2&"
import script from "./SuppliesStatistic.vue?vue&type=script&lang=js&"
export * from "./SuppliesStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports